import { ModalType } from './modal-type';

// tslint:disable:whitespace

export class ModalOptions {
  headerText? = 'Alert Message';
  bodyText: string;
  confirmButtonText? = 'OK';
  confirmSecondaryButtonText? = 'OK';
  cancelButtonText? = 'Cancel';
  modalType?: ModalType;
  showCloseButton? = true;
}
